/**
 * Tour config — LOCALHOST (npm run dev).
 *
 * Anything not listed here is OFF (false by default). To control a tour in this
 * environment, edit its entry below. Fields: enabled, autoStart, startDate, endDate.
 * See ../README.md for the full guide.
 */

import type { TourConfig } from './types';

export const config: TourConfig = {
  announcements: {
    enabled: true,
    autoStart: true,
    startDate: null,
    endDate: null
  }
};
